// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf /*, maybe */ } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isAppsCatalogFieldsResult = objectOf({
  catalog_fields: arrayOf(
    objectOf({
      name: string,
      token: string,
      type: string,
    })
  ),
});
